import React, { useState, useEffect, FC } from 'react'
import { Table } from 'antd'
import { Link, Redirect } from 'react-router-dom'
import { ServiceProvider } from '../../types'
import { serviceProviderService } from '../../services'
import { SearchBar, Page } from '../../components'
import styles from './index.module.less'
import { useAuth } from '../../providers/AuthProvider'

const { Column } = Table

const ServiceProviders: FC = () => {
	const [filter, setFilter] = useState<string>('')
	const [isLoading, setIsLoading] = useState<boolean>(false)
	const [serviceProviders, setServiceProviders] = useState<ServiceProvider[]>([])
	const { userHasPermission, user } = useAuth()
	const isMondagoAdmin = userHasPermission(['ServiceProvider.All.ReadWrite'])

	useEffect(() => {
		if (isMondagoAdmin || user.service_providers.length > 1) {
			const initServiceProviders = async (): Promise<void> => {
				setIsLoading(true)
				const { data } = await serviceProviderService.getAll()
				setServiceProviders(data)
				setIsLoading(false)
			}

			initServiceProviders()
		}
	}, [isMondagoAdmin, user])

	if (!isMondagoAdmin && user.service_providers.length === 1) {
		const serviceProviderPath = `/serviceprovider/${user.service_providers[0].id}/children`
		return <Redirect to={serviceProviderPath} />
	}

	if (!isMondagoAdmin && user.resellers.length === 1) {
		const serviceProviderPath = `/reseller/${user.resellers[0].id}/children`
		return <Redirect to={serviceProviderPath} />
	}

	return (
		<Page title='Service Providers'>
			<SearchBar className={styles.search} search={setFilter} placeholder='Filter by name' />
			<Table
				dataSource={serviceProviders.filter(sp => (filter.length ? sp.name.toLowerCase().includes(filter.toLowerCase()) : true))}
				loading={isLoading}
				rowKey='id'
			>
				<Column
					title='Name'
					dataIndex='name'
					render={(name: string, record: ServiceProvider): React.ReactNode => <Link to={`/serviceprovider/${record.id}/children`}>{name}</Link>}
				/>
			</Table>
		</Page>
	)
}

export default ServiceProviders
